export default {
  name: 'SearchInput',
};
